import {
  EMAIL_CHANNEL_DELETE_FETCH,
  EMAIL_CHANNEL_DELETE_FETCH_FAIL,
  EMAIL_CHANNEL_DELETE_FETCH_SUCCESS,
  EMAIL_CHANNEL_CREATE_FETCH,
  EMAIL_CHANNEL_CREATE_FETCH_FAIL,
  EMAIL_CHANNEL_CREATE_FETCH_SUCCESS,
  EMAIL_CHANNEL_LIST_FETCH,
  EMAIL_CHANNEL_LIST_FETCH_FAIL,
  EMAIL_CHANNEL_LIST_FETCH_SUCCESS,
  EMAIL_CHANNEL_UPDATE_FETCH,
  EMAIL_CHANNEL_UPDATE_FETCH_FAIL,
  EMAIL_CHANNEL_UPDATE_FETCH_SUCCESS,
  EMAIL_CHANNEL_UPDATE_SUBMIT_FETCH,
  EMAIL_CHANNEL_UPDATE_SUBMIT_FETCH_FAIL,
  EMAIL_CHANNEL_UPDATE_SUBMIT_FETCH_SUCCESS,
  EMAIL_CHANNEL_CHANGE_CURRENT,
  EMAIL_CHANNEL_PAGE_CHANGE_CURRENT,
  EMAIL_CHANNEL_SEARCH_LIST_FETCH,
  EMAIL_CHANNEL_SEARCH_LIST_FETCH_SUCCESS,
  EMAIL_CHANNEL_SEARCH_LIST_FETCH_FAIL,
} from './EmailChannelConstants';

const initialState = {
  page: {},
  loadingList: false,
  loadingSearchList: false,
  pageRequest: {},
  errors: [],

  currentEmailChannel: {},

  errorsUpdate: [],
  loadingUpdate: false,

  errorsUpdateSubmit: [],
  loadingUpdateSubmit: false,

  errorsDelete: [],
  loadingDelete: false,

  errorsCreate: [],
  loadingCreate: false,
};

// eslint-disable-next-line complexity
export default function EmailChannelState(state = initialState, action) {
  switch (action.type) {
    case EMAIL_CHANNEL_LIST_FETCH:
      return { ...state, pageRequest: action.payload, loadingList: true };
    case EMAIL_CHANNEL_LIST_FETCH_SUCCESS:
      return { ...state, page: action.payload, loadingList: false };
    case EMAIL_CHANNEL_LIST_FETCH_FAIL:
      return { ...state, errors: action.payload.errors, loadingList: false };

    case EMAIL_CHANNEL_SEARCH_LIST_FETCH:
      return { ...state, pageRequest: action.payload, loadingSearchList: true };
    case EMAIL_CHANNEL_SEARCH_LIST_FETCH_SUCCESS:
      return { ...state, page: action.payload, loadingSearchList: false };
    case EMAIL_CHANNEL_SEARCH_LIST_FETCH_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loadingSearchList: false,
      };

    case EMAIL_CHANNEL_UPDATE_SUBMIT_FETCH:
      return { ...state, loadingUpdateSubmit: true };
    case EMAIL_CHANNEL_UPDATE_SUBMIT_FETCH_FAIL:
      return {
        ...state,
        errorsUpdateSubmit: action.payload.errors,
        loadingUpdateSubmit: false,
      };
    case EMAIL_CHANNEL_UPDATE_SUBMIT_FETCH_SUCCESS:
      return { ...state, loadingUpdateSubmit: false };

    case EMAIL_CHANNEL_UPDATE_FETCH:
      return { ...state, loadingUpdate: true };
    case EMAIL_CHANNEL_UPDATE_FETCH_FAIL:
      return {
        ...state,
        errorsUpdate: action.payload.errors,
        loadingUpdate: false,
      };
    case EMAIL_CHANNEL_UPDATE_FETCH_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        currentEmailChannel: action.payload,
      };

    case EMAIL_CHANNEL_CREATE_FETCH:
      return { ...state, loadingCreate: true };
    case EMAIL_CHANNEL_CREATE_FETCH_FAIL:
      return {
        ...state,
        errorsCreate: action.payload.errors,
        loadingCreate: false,
      };
    case EMAIL_CHANNEL_CREATE_FETCH_SUCCESS:
      return { ...state, loadingCreate: false };

    case EMAIL_CHANNEL_DELETE_FETCH:
      return { ...state, loadingDelete: true };
    case EMAIL_CHANNEL_DELETE_FETCH_FAIL:
      return {
        ...state,
        errorsDelete: action.payload.errors,
        loadingDelete: false,
      };
    case EMAIL_CHANNEL_DELETE_FETCH_SUCCESS:
      return { ...state, loadingDelete: false };

    case EMAIL_CHANNEL_CHANGE_CURRENT:
      return { ...state, currentEmailChannel: action.payload };

    case EMAIL_CHANNEL_PAGE_CHANGE_CURRENT:
      return { ...state, pageRequest: action.payload };

    default:
      return state;
  }
}
